import React from "react";
import Modal from "@mui/material/Modal";
import { styled } from "@mui/system";
import { Paper } from "@mui/material";
import { CButton, CCol, CRow } from "@coreui/react";
import CommonList from "src/views/common/CommonList";
import { apiCallResponse } from "src/_apiConfig/apiCall";
//import CustomeModalPopup from "src/views/common/CustomeModalPopup";

const ModalPaymentTransactionHistory = (props) => {
  const Backdrop = styled("div")`
    z-index: -1;
    position: fixed;
    right: 0;
    bottom: 0;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.2);
    -webkit-tap-highlight-color: transparent;
  `;
  const styleViewTransaction = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 1200,
    minHeight: 400,
    borderRadius: "4px",
    fontSize: "1rem",
    padding: "2rem",
  };

  const hidepaymentHistory = () => props.setshowpaymentHistory(false);

  const CheckTransactionStatus = async (lotId, paymentType, grfeId = 0) => {
    console.log("CheckTransactionStatus : ", lotId, paymentType, grfeId);
    const header = new Headers();
    header.append("Content-Type", "application/json");

    const data = JSON.stringify({
      LotId: lotId,
      PaymentType: paymentType,
      otherId: Number(grfeId) === 0 ? "" : grfeId,
    });
    await apiCallResponse(
      "PaymentHistory/CheckStatus",
      "POST",
      header,
      data,
      []
    ).then((res) => {
      if (res.success) {
        props.setpaymentTransactionHistory(res.data);
      } else {
        props.setpaymentTransactionHistory([]);
      }
      props.setshowpaymentHistory(true);
    });
  };
  const fieldsPaymentHistory = [
    {
      key: "paymentId",
      label: "Payment Id",
    },
    {
      key: "dateTime",
      label: "Transaction Date",
    },
    {
      key: "responseMessage",
      label: "Reference No",
    },
    {
      key: "challanNumber",
      label: "Challan No",
    },
    {
      key: "amount",
      label: "Amount",
    },
    {
      key: "statusCode",
      label: "StatusCode",
    },
  ];
  return (
    // <CustomeModalPopup
    //   onOpen={props.showpaymentHistory}
    //   onClose={hidepaymentHistory}
    //   onSubmitButton={CheckTransactionStatus(
    //     props.LotId,
    //     props.paymentType,
    //     props.grfeId
    //   )}
    //   onCloseButton={hidepaymentHistory}
    //   popupWith={1200}
    //   minHeight={400}
    //   body={
    //     <>
    //       <CommonList
    //         items={props.paymentTransactionHistory}
    //         fields={fieldsPaymentHistory}
    //         listName={"Payment History" + props.showpaymentHistory}
    //         loading={false}
    //         path="/lotlistview/"
    //         tabBtn="View"
    //         id="lotId"
    //         disabledprev={true}
    //         disablednext={true}
    //       />
    //     </>
    //   }
    //   isFromSubmit={false}
    //   isSubmitBtnDisabled={false}
    //   ButtonLoader={false}
    //   disabledBtn={false}
    //   btnSubmitClass={""}
    //   btnSubmitText={"Refresh"}
    //   btnCloseClass={""}
    //   btnCloseText={"Close"}
    // />
    <>
      <Modal
        open={props.showpaymentHistory}
        onClose={hidepaymentHistory}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        BackdropComponent={Backdrop}
      >
        <Paper style={styleViewTransaction} elevation={12}>
          <CRow>
            <CCol xl={12}>
              <CommonList
                items={props.paymentTransactionHistory}
                fields={fieldsPaymentHistory}
                listName="Payment History"
                loading={false}
                path="/lotlistview/"
                tabBtn="View"
                id="lotId"
                disabledprev={true}
                disablednext={true}
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol xl={10}></CCol>
            <CCol xl={2}>
              <CButton
                className="mt-3"
                color="success"
                type="button"
                onClick={() => {
                  CheckTransactionStatus(
                    props.LotId,
                    props.paymentType,
                    props.grfeId
                  );
                }}
              >
                Refresh
              </CButton>
              <CButton
                className="mt-3 ml-2 btn btn-dark"
                color="success"
                type="button"
                onClick={() => hidepaymentHistory()}
              >
                Close
              </CButton>
            </CCol>
          </CRow>
        </Paper>
      </Modal>
    </>
  );
};

export default ModalPaymentTransactionHistory;
